import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import employees from 'modules/employees/store/collections/employees'
import { BULK_IMPORT_SUPPLEMENT, PAYROLL_RESULT } from 'modules/payroll_bundle/lib/constants'

interface ModalProps {
  type: string
  index: number
  onClose: () => void
  selectedEmployee: number | null
  employeeSelector: React.ReactNode
  onAssignEmployee: (userId: number, index: number) => void
}

const AssignModal = ({
  type,
  index,
  onClose,
  employeeSelector,
  onAssignEmployee,
  selectedEmployee,
}: ModalProps) => {
  const onConfirm = (selectedEmployee: number | null | undefined, index: number) => {
    const employee = employees.find({
      id: selectedEmployee,
    })

    if (employee) {
      onAssignEmployee(employee.id, index)
    }
    onClose()
  }

  const title = () => {
    switch (type) {
      case BULK_IMPORT_SUPPLEMENT:
        return i18n.t('payroll_bundle.supplements.bulk_import.assign_modal.title')
      case PAYROLL_RESULT:
        return i18n.t('payroll_bundle.sepa_generator.matcher.modal.title')
      default:
        return ''
    }
  }

  const description = () => {
    switch (type) {
      case BULK_IMPORT_SUPPLEMENT:
        return i18n.t('payroll_bundle.supplements.bulk_import.assign_modal.description')
      case PAYROLL_RESULT:
        return i18n.t('payroll_bundle.sepa_generator.matcher.modal.description')
      default:
        return ''
    }
  }

  const button = i18n.t('payroll_bundle.sepa_generator.matcher.modal.button')

  return (
    <Modal
      title={title()}
      illustration="user-edit"
      description={description()}
      footer={
        <Button onClick={() => onConfirm(selectedEmployee, index)} disabled={!selectedEmployee}>
          {button}
        </Button>
      }
      onClose={onClose}
    >
      <Box>{employeeSelector}</Box>
    </Modal>
  )
}

export default AssignModal
